var App = App || {};

App.BlockCompare = (function ($) {
    'use strict';

    var Bps = ["xs", "sm", "md"],
        Bp = ZAGFramework.GetCurrentBP(),
        Mobile = false;

    function init() {

        $(".block-compare").each(function () {

            const Component = $(this);
            const Controls = Component.find(".block-compare-controls").length != 0;

            if (Controls) {
                if (Bps.includes(Bp)) { CompareSetup(Component) }
                $(document).on("enter-xs enter-sm enter-md", function () { CompareSetup(Component) });
                $(document).on("enter-lg enter-xl enter-xxl", function () { CompareMobileKill(Component) });
            }
        });

    }

    function CompareSetup(Component) {

        if (Mobile == false) {

            var Controls = Component.find(".block-compare-controls").find(".form-check-input");
            Controls.on("change", function () { CompareUpdate(Component); });

            Controls.prop("checked", false);
            $(Controls[0]).prop("checked", true);
            $(Controls[1]).prop("checked", true);

            CompareUpdate(Component);

            Mobile = true;
        }

    }

    function CompareUpdate(Component) {

        var Controls = Component.find(".block-compare-controls"),
            ChartContent = Component.find(".block-compare-content"),
            ControlsChecked = [],
            ColumnsWidth = 0;

        Controls.find(".form-check-input").each(function () {
            if ($(this).prop("checked")) {
                ControlsChecked.push($(this).attr("id"));
            }
        });

        if (!ControlsChecked.length) {
            ChartContent.hide();
        }
        else {
            ChartContent.show();
            ColumnsWidth = 100 / ControlsChecked.length;
        }

        Component.find("[data-controlledby]").each(function () {

            var Control = $(this).attr("data-controlledby");

            if (ControlsChecked.includes(Control)) {
                $(this)
                    .css({ width: ColumnsWidth + "%" })
                    .show();
            }
            else {
                $(this)
                    .removeAttr("style")
                    .hide();
            }
        });
    }

    function CompareMobileKill(Component) {

        var ChartContent = Component.find(".block-compare-content"),
            ChartColumns = Component.find(".block-compare-content").find("[data-controlledby]");

        if (Mobile == true) {
            ChartContent.show();
            ChartColumns.show();
            Mobile = false;
        }
    }

    return {
        init: init
    };

})(jQuery);

$(function () {
    App.BlockCompare.init();
});